import api from '../api'

import {
  fetchClientsStart,
  fetchClientsSuccess,
  fetchClientsFail,
} from '../reducers/endpoints/clients'
import {take, put, call} from 'redux-saga/effects'

export function* fetchClients(mss) {
  console.log('VALUES ON CLIENT: ', mss)
  let empresaId = mss.mss.empresaId
  const url = `/cliente/getporempresa/${empresaId}`

  //const userToken = localStorage.getItem('token')

  const headerParams = {
    headers: {
  //    Authorization: `Bearer ${ userToken }`
    }
  }

  try {
    const {data: clients} = yield call([api, 'get'], url, headerParams)
    //console.log('***************',Clients)
    yield put(fetchClientsSuccess(clients))
  } catch (error) {
    yield put(fetchClientsFail(error))
  }
}

export function* watchFetchClients() {
  while (true) {
    //yield take(fetchClientsStart)
    const {
      payload: mss
    } = yield take(fetchClientsStart)
    yield call(fetchClients, mss)
    //yield call(fetchClients, {empresaId: "10004"})
  }
}